import Image from 'next/image';

import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { Box } from '../Box';
import { Text } from '../Text';

export const BoxWithBorder = styled(Box)`
  border-bottom: ${({ theme }) => `1px solid ${theme.color.collapsibleBorder}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// The following font-sizes are hard-coded per legal requirements
export const LegalText = styled(Text)`
  font-size: 22px;

  ${mediaQueries.desktop} {
    font-size: 26px;
  }
`;

export const Icon = styled(Image)`
  min-height: 10px;
`;
